import axios, { AxiosInstance } from 'axios'

interface LoginRequest {
  email: string
  password: string
}

class LoginService {
  private client
  constructor() {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_HEMISPHERE_URL
    })
  }
  public login(user: LoginRequest): Promise<any> {
    return this.client.post('/users/signin', {
      email: user.email,
      password: user.password
    })
  }

  public login2(accessToken: string): Promise<any> {
    return this.client.get('/users/user/token', {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })
  }
}

const loginService = new LoginService()

export default loginService
